import React from "react";
import { CustomerSettingsContextType } from "./CustomerSettingsContextType";

export const CustomerSettingsContext = React.createContext<
  CustomerSettingsContextType | undefined
>(undefined);
